import React from 'react';

// React Bootstrap
import { Container, Row, Col, Card } from 'react-bootstrap';

// Packages
import PropTypes from 'prop-types';

// Components
import StatusBadge from '../../utils/StatusBadge';

// Utils
import { getWorkerStatusDesc } from '../../../utils/getStatusDesc';

const Helper = (props) => {
	const { helper } = props;

	return (
		<Card className='shadow mb-4 bg-body rounded card-border' style={{ cursor: 'pointer' }}
			onClick={() => window.open(`/helper/${helper._id.$oid}/resource/${helper.resource._id.$oid}`, '_self')}
		>
			<Container>
				<Row>
					<Col>
						<Card.Body className='ps-0'>
							<Card.Title as='h6'>{helper.name}</Card.Title>
							<Card.Subtitle className='mb-2 text-muted' as='p'>{helper.description}</Card.Subtitle>
							<Card.Text>
								<strong>Id:</strong> {helper._id.$oid} - <strong>Alias:</strong> {helper.alias} - <StatusBadge status={getWorkerStatusDesc(helper.status)} />
							</Card.Text>
						</Card.Body>
					</Col>
				</Row>
			</Container>
		</Card>
	);
}

Helper.propTypes = {
	helper: PropTypes.object.isRequired
}

export default Helper;
